import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';

export default function AdminDialogShell({
  open,
  onClose,
  title,
  description,
  actions,
  children,
  maxWidth = 'md',
  fullWidth = true,
  dividers = true,
  scroll = 'paper',
  contentSx,
  actionsSx,
  dialogProps,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      scroll={scroll}
      {...dialogProps}
    >
      <DialogTitle sx={{ pb: description ? 1 : 2 }}>
        {description ? (
          <Stack spacing={0.5}>
            <Typography variant="h6" fontWeight={700}>
              {title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          </Stack>
        ) : title}
      </DialogTitle>
      <DialogContent dividers={dividers} sx={contentSx}>
        {children}
      </DialogContent>
      {actions ? (
        <DialogActions sx={{ px: 3, py: 2, gap: 1, ...actionsSx }}>
          {actions}
        </DialogActions>
      ) : null}
    </Dialog>
  );
}